import { useNavigate } from "react-router-dom";
import Shell from "../components/Shell.jsx";
import TransactionForm from "../components/TransactionForm.jsx";

export default function AddEntry() {
  const navigate = useNavigate();
  return (
    <Shell title="Add entry" back>
      <div className="rounded-2xl bg-white p-5 shadow-sm">
        <TransactionForm submitLabel="Save entry" onSaved={() => navigate("/ledger")} />
      </div>
    </Shell>
  );
}
